const getters = {
    isLoading: state => state.user.isLoading,
}

export default getters;